import React, { useState, useEffect } from "react"
import { CardBody, Container, Row, Col, Card, Button, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer } from "react-toastify"
import { useHistory } from "react-router-dom"
import { URLS } from "../../Url"
import axios from "axios"

function State() {
  const [Recharge, setRecharge] = useState([])

  const history = useHistory()

  useEffect(() => {
    GetOneActins()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const Actinid = sessionStorage.getItem("RechargeId")

  const GetOneActins = () => {
    const data = {
      id: Actinid,
    }
    var token = datas
    axios
      .post(URLS.GetOneRecharge, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setRecharge(res?.data?.data[0])
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home " breadcrumbItem="View Services" />
          <Row>
            <Col>
              <Button
                onClick={() => history.goBack()}
                className="mb-3  m-1 "
                style={{ float: "right" }}
                color="primary"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Button>
            </Col>
          </Row>
          <Row className="mb-5">
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row className="d-flex justify-content-center">
                    <Col lg={8}>
                      <div className="table-rep-plugin mt-4 table-responsive">
                        <Table hover className="table table-bordered mb-4 ">
                          <thead>
                            <tr className="text-center">
                              <th>Date / Time </th>
                              <td>
                                {Recharge?.paymentDate} -{" "}
                                {Recharge?.paymentTime}
                              </td>
                            </tr>
                            <tr className="text-center">
                              <th>User Name</th>
                              <td>{Recharge?.userName}</td>
                            </tr>
                            <tr className="text-center">
                              <th>User Mobile</th>
                              <td>{Recharge?.userPhone}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Category Name</th>
                              <td>{Recharge?.category}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Service Number</th>
                              <td>{Recharge?.number}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Operator</th>
                              <td>{Recharge?.operator}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Operator Code</th>
                              <td>{Recharge?.operatorCode}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Circle</th>
                              <td>{Recharge?.circle}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Circle Code</th>
                              <td>{Recharge?.circleCode}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Amount</th>
                              <td>{Recharge?.paymentTransactionAmount}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Charge</th>
                              <td>{Recharge?.paymentWalletSpent}%</td>
                            </tr>
                            <tr className="text-center">
                              <th>Transtation Id</th>
                              <td>{Recharge?.paymentTransactionId}</td>
                            </tr>
                            <tr className="text-center">
                              <th>Status</th>
                              <td>
                                <span className="badge bg-success">
                                  {Recharge?.paymentStatus}
                                </span>
                              </td>
                            </tr>
                          </thead>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default State
